import memoize from 'lodash-es/memoize';
import * as path2regex from 'path-to-regexp';
import { stringify } from 'query-string';

// cache compiled patterns
const cachedPath2RegexCompile = memoize(path2regex.compile);

export function url(
    urlPattern: string,
    keys: {[name: string]: string | number},
    getParams?: {[key: string]: string | number},
) {
    const pathRe = cachedPath2RegexCompile(urlPattern);
    let surl = pathRe(keys);

    if (getParams && Object.keys(getParams).length > 0) {
        const qs = stringify(getParams);
        surl = surl + '?' + qs;
    }

    return surl;
}
